import { type ExperimentValue } from '@stone-payments/experiment/src/lib/types'

export enum MarketProductTagExperimentEnum {
  Promotional = 'promotional',
  LastTime = 'last-time',
  ImmediateRedemption = 'immediate-redemption'
}

export enum MarketProductTagScreenEnum {
  ProductList = 'product_list',
  ProductDetails = 'product_details',
  DepositAmount = 'deposit_amount',
  DepositConfirmation = 'deposit_confirmation'
}

export type MarketProductTagExperimentItem = {
  tag?: string
  icon?: string | null
  label?: string
  screens?: string[]
  variant?: string
  under_title_label?: string
}

export type MarketProductTagsExperimentPayload = {
  tags?: MarketProductTagExperimentItem[]
}

export const defaultMarketProductTagsExperimentPayload: ExperimentValue<MarketProductTagsExperimentPayload> = {
  value: 'control',
  payload: { tags: [] }
}
